import { Model } from '../../../shared/models/model.class';
import { DealContactOverrides } from 'ng2-app/models/deals/deal-contact-overrides.model';

export class Deal extends Model<Deal> {

    static categoryStages: {
        [key: string]: Array<string>;
    } = {
        'funded': ['funded'],
        'active': ['application', 'underwriting', 'closing'],
        'inactive': ['inactive']
    };

    static filterBorrowerDealsByStages = function (deals, stages) {
        return deals.filter((deal) => stages.includes(deal.stage));
    };

    static filterBorrowerDealsByCategory = function (deals, category) {
        return Deal.categoryStages[category] ?
            Deal.filterBorrowerDealsByStages(deals, Deal.categoryStages[category]) :
            [];
    };

    borrowerId: number;
    modified: Date;
    amount: number;
    stage: string;
    status: string;
    type: string;
    loan_product_lender: any;
    loan_product: any;
    loanProductLenderName: string;
    loanProductName: string;
    contact_overrides?: DealContactOverrides;

    fillable() {
        return [
            'id',
            'borrowerId',
            'acceptedOfferId',
            'amount',
            'stage',
            'status',
            'type',
            'loan_product_lender',
            'loan_product'
        ];
    }

    serializeable() {
        return this.fillable();
    }

}
